<template>
  <!-- 上传文档的操作区域封装组件 -->
  <div class="uploadAction">
    <div v-if="showFlag">
      <div class="form-group row">
        <label class="">下载模板：</label>
        <div class="col-md-10" style="padding-left: 5px">
          <a-button @click="download" style="background: #2caf7a;border: 1px solid #2caf7a;color: #fff">下载模板</a-button>
        </div>
      </div>
      <label class="">上传表格：</label>
      <a-upload
        :file-list="fileList"
        :remove="handleRemove"
        :before-upload="beforeUpload"
        accept=".doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      >
        <a-button class="uploads"> <a-icon type="upload" />选择文件</a-button>
      </a-upload>
      <div class="form-group row">
        <label class="">备注：</label>
        <div class="col-md-10" style="padding-left: 5px">
          <textarea rows="5" v-model="remark" class="form-control"></textarea>
        </div>
      </div>
      <button
        type="primary"
        :disabled="fileList.length === 0"
        :loading="uploading"
        style="margin-top: 16px; margin-left: 105px"
        @click="handleUpload"
        class="btn btn-info"
        :class="{ disabled: fileList.length === 0 }"
      >
        {{ uploading ? "上传中" : title }}
      </button>
      <!-- <button class="btn btn-info" type="upload">重新上传</button> -->
      <!-- <a-upload
        name="file"
        :multiple="true"
        :action="`${axios.defaults.baseURL}/common/upload`"
        @change="handleChange"
        :before-upload="beforeUpload1"
        accept=".doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      >
        <button class="btn btn-info" type="upload">重新上传</button>
      </a-upload> -->
    </div>
    <span class="btn-text" v-if="checkFlag"
      >*您所上传的文档已被老师审核通过，无需重新上传</span
    >
    <span class="btn-text" v-else
      >*选择文件后，点击{{ title }}按钮即可重新上传文档</span
    >
  </div>
</template>

<script>
export default {
  mounted() {
    console.log(this.axios.defaults.baseURL);
    if (!this.docUrl) {
      this.showFlag = true;
    } else if (!this.checkFlag) {
      this.showFlag = true;
      this.title = "重新上传";
    }
  },
  props: {
    docUrl: {
      required: true,
      type: String,
    },
    checkFlag: {
      required: true,
      type: Boolean,
    },
    type: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      fileList: [],
      uploading: false,
      remark: "",
      title: "上传",
      showFlag: false,
      paramKey:'default_rxdjxxb'
    };
  },
  methods: {
    download(){
      console.log(this.$route)
      if(this.$route.name == 'RegistrationCheck'){
        this.paramKey = 'default_byzgscb'
      }else if(this.$route.name == 'RegistrationForm'){
        this.paramKey = 'default_byxsdjb'
      } else {
        this.paramKey = 'default_rxdjxxb'
      }
      this.axios.get(`/student/departParam/all`,{
        params:{
          eduCode:JSON.parse(localStorage.getItem('userInfo')).eduCode,
          paramKey:this.paramKey
        }
      }).then(res=>{
        console.log(res)
        if(res.code === 200){
          window.open(res.result[0].paramVal)
        }
      })
    },
    /** 该函数是在向服务器上传文件之前的拦截器，判断上传的文件是否符合规则（文件类型为.doc和.docx，文件大小不得大于20MB）
     * @param {object} file 上传文件的对象
     */
    beforeUpload(file) {
      // application/vnd.openxmlformats-officedocument.wordprocessingml.document
      // application/msword
      // 这两个type类型分别为.doc和.docx
      //   const isJpgOrPng =
      //     file.type ===
      //       "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      //     file.type === "application/msword";
      //   if (!isJpgOrPng) {
      //     this.$message.error("只能上传word文档！");
      //   }
      //   const isLt2M = file.size / 1024 / 1024 < 20;
      //   if (!isLt2M) {
      //     this.$message.error("只能上传小于20MB的文档！");
      //   }
      //   return isJpgOrPng && isLt2M;
      this.fileList = [file];
      return false;
    },
    beforeUpload1(file) {
      const isJpgOrPng =
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/msword";
      if (!isJpgOrPng) {
        this.$message.error("只能上传word文档！");
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error("只能上传小于20MB的文档！");
      }
      return isJpgOrPng && isLt2M;
    },
    handleChange(data) {
      console.log(data);
    },
    handleUpload() {
      const { fileList } = this;
      console.log(fileList);
      const formData = new FormData();
      formData.append("file", fileList[0]);
      this.uploading = true;
      this.axios
        .post(`/common/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.success && res.result) {
            this.axios
              .get(`/biz/archive/doc/upload`, {
                params: {
                  target: res.result,
                  targetName: fileList[0].name,
                  type: this.type,
                  remark: this.remark,
                },
              })
              .then((res2) => {
                if (res.success) {
                  this.uploading = false;
                  this.fileList = [];
                  this.remark = "";
                  this.$message.success("上传成功！");
                  this.$emit("uploadSuccess");
                } else {
                  this.$message.error(res.message);
                }
              });
          }
        });
    },
    handleRemove() {},
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.btn {
  background: $bgColor;
  color: #fff;
  width: 120px;
  margin: 20px;
}

.btn-info {
  background: $bgColor;
}

.btn-text {
  color: #c4c4c4;
  display: block;
  margin: 10px 0;
}

.form-group {
  margin: 10px 0;
  display: flex;
  align-items: center;
}

.uploads {
  width: 400px;
  height: 100px;
  color: $bgColor;
  display: inline-block;
  font-size: 16px;
}

.uploadAction {
  label {
    width: 100px;
  }
}

.customScrollBar div::-webkit-scrollbar-thumb {
  background-color: $bgColor !important;
}

.WACFrameWord {
  /* background: top left repeat-x #ffffff; */
  /* background-attachment: fixed; */
  /* background-image: -webkit-gradient(linear,left top,left bottom,from(#ffffff),to(#F3F3F3)); */
  /* background-image: -moz-linear-gradient(top,#ffffff,#F3F3F3);
  background-image: -ms-linear-gradient(top,#ffffff,#F3F3F3); */
  background: #f00 !important;
}

.disabled {
  background-color: #cccccc!important;
  border: none;
}
</style>

<style>
.disabled {
  background-color: #cccccc!important;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/uploadAction.vue